import axios from "axios";
import React, { useCallback, useMemo, useState } from "react";
import EventDescription from "../events/eventDescription";

import {
  Button,
  ButtonGroup,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

export default function EventsPerLeague(props) {
  const userInfo = useMemo(
    () => JSON.parse(localStorage.getItem("userInfo")),
    []
  );

  const [eventId, setEventId] = useState(0);
  const [edit, setEdit] = useState(false);

  /* se quito el ,[] que se puede para no hacer tantos renders*/
  const options = {
    page: 1, // which page you want to show as default
    sizePerPageList: [
      {
        text: "15",
        value: 15,
      },
      {
        text: "50",
        value: 50,
      },
      {
        text: "500",
        value: 500,
      },
      {
        text: "1000",
        value: 1000,
      },
    ], // you can change the dropdown list for size per page
    sizePerPage: 16, // which size per page you want to locate as default
    pageStartIndex: 1, // where to start counting the pages
    paginationSize: 3, // the pagination bar size.
    prePage: "Prev", // Previous page button text
    nextPage: "Next", // Next page button text
    firstPage: "First", // First page button text
    lastPage: "Last", // Last page button text
    paginationShowsTotal: true, // Accept bool or function
    paginationPosition: "bottom", // default is bottom, top and both is all available
    onRowClick: selectedValues,
  };

  const handleEdit = function () {
    setEdit(false);
  };

  function selectedValues(row) {
    setEdit(true);
    setEventId(row.idEvent);
  }

  const [selected, setSelected] = useState([]);
  const onSelect = useCallback(
    (row, isSelected, e) =>
      isSelected
        ? setSelected((currentSelected) => [...currentSelected, row])
        : setSelected((currentSelected) =>
          currentSelected.filter((x) => x !== row)
        ),
    []
  );

  const onSelectAll = useCallback(
    (isSelected, rows) => (isSelected ? setSelected(rows) : setSelected([])),
    []
  );

  const selectRowProp = {
    mode: "checkbox",
    onSelect,
    onSelectAll,
  };

  const onDelete = useCallback(() => {
    Promise.all(
      selected.map(({ idEvent }, index) =>
        axios.post(`${process.env.REACT_APP_API2_URL}/Events/Event_Delete`, {
          IdEvent: idEvent,
          IdUser: Number(userInfo.userId),
        })
      )
    ).then(() => props.RequestEvents(props.IdLeague));
  }, [selected, userInfo, props]);

  const [open, setOpen] = React.useState(false);
  const handleDelete = () => {
    setOpen(true);
  };

  const handleClose = (confirm) => {
    if (confirm) {
      onDelete();
    }
    setOpen(false);
  };

  const handleInsert = () => {
    setEventId(null);
    setEdit(true);
  };

  return (
    <div className="flex flex-col flex-1 gap-4">
      {edit ? (
        <EventDescription
          EventId={eventId}
          LeagueId={props.IdLeague}
          onClose={handleEdit}
          RequestEvents={props.RequestEvents}
        />
      ) : (
        ""
      )}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>Delete events</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete {selected.length} record{" "}
            {selected.length > 1 ? "(s)" : ""}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => handleClose(false)}
            color="secondary"
            variant="contained"
            autoFocus
          >
            Cancel
          </Button>
          <Button
            onClick={() => handleClose(true)}
            color="primary"
            variant="contained"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <div className="flex flex-row items-center justify-between">
        <Button
          variant="contained"
          color="primary"
          onClick={() => props.RequestEvents(props.IdLeague)}
        >
          Refresh
        </Button>

        <ButtonGroup
          variant="contained"
          color="primary"
          aria-label="contained primary button group"
        >
          <Button onClick={handleInsert}>Insert</Button>
          <Button disabled={selected.length === 0} onClick={handleDelete}>
            Delete
          </Button>
        </ButtonGroup>
      </div>
      <BootstrapTable
        selectRow={selectRowProp}
        data={props.EventsLeagues}
        options={options}
        pagination={true}
        version="4"
        hover
      >
        <TableHeaderColumn
          visible="none"
          isKey={true}
          hidden
          hiddenOnInsert
          dataField="idEvent"
        >
          ID
        </TableHeaderColumn>
        <TableHeaderColumn dataField="eventOrder">Order</TableHeaderColumn>
        <TableHeaderColumn dataField="description">
          Description
        </TableHeaderColumn>
        <TableHeaderColumn dataField="targetLeagueDesc">
          Target League
        </TableHeaderColumn>
      </BootstrapTable>
    </div>
  );
}
